package com.tixforgigs.common.ui.pages.login

import com.tixforgigs.apax.models.ResetPasswordRequest
import com.tixforgigs.common.CommonBuildKonfig
import com.tixforgigs.common.core.enums.MandarinInputType
import com.tixforgigs.common.core.enums.View
import com.tixforgigs.common.core.extensions.RoutingUtil.AppScope
import com.tixforgigs.common.core.interfaces.StorefrontPage
import com.tixforgigs.common.core.models.ui.InputState
import com.tixforgigs.common.core.util.InputUtil.emailRegex
import com.tixforgigs.common.core.util.LocalizationUtil.currentTranslationLocale
import com.tixforgigs.common.core.util.TrackerUtil.pageView
import com.tixforgigs.common.http.ApiPostPath
import com.tixforgigs.common.http.HttpClient.BASE_URL
import com.tixforgigs.common.http.HttpClient.apiV4Post
import com.tixforgigs.common.ui.components.grid.gridContainer
import com.tixforgigs.common.ui.components.mandarin.mandarinFilledButton
import com.tixforgigs.common.ui.components.mandarin.mandarinInput
import com.tixforgigs.common.ui.components.mandarin.mandarinTitle
import com.tixforgigs.common.ui.components.root.defaultTemplate
import com.tixforgigs.tarami.GlobalMessage.buttonTextEmailSend
import com.tixforgigs.tarami.GlobalMessage.titlePasswordForgot
import de.comahe.i18n4k.language
import io.kvision.core.JustifyItems
import io.kvision.material.ExperimentalMaterialApi
import io.kvision.panel.SimplePanel
import io.kvision.panel.simplePanel
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.launch
import kotlin.time.ExperimentalTime


@OptIn(ExperimentalMaterialApi::class, ExperimentalTime::class)
class ForgotPasswordView() : SimplePanel(className = "xm-page xm-page-auth-forgot-password"), StorefrontPage {

  override val VIEW: View get() = View.FORGOT_PASSWORD

  val mEmailInput =
    MutableStateFlow<InputState<String?>>(
      InputState(
        CommonBuildKonfig.TEST_USER, CommonBuildKonfig.TEST_USER.matches(emailRegex)
      )
    )

  init {
    AppScope.launch {
      pageView()
    }

    defaultTemplate {
      simplePanel(className = "xm-body") {

        gridContainer {
          gridItem(12) {
            mandarinTitle(titlePasswordForgot())
          }
          gridItem(12) {
            mandarinInput(state = mEmailInput, inputType = MandarinInputType.EMAIL)
          }
          gridItem(12, horizontalAlign = JustifyItems.END) {
            mandarinFilledButton(
              title = buttonTextEmailSend(),
              isEnabled = mEmailInput.map { it.isValid }
                .stateIn(AppScope, SharingStarted.Eagerly, mEmailInput.value.isValid)
            ) {
              apiV4Post<Unit>(
                type = ApiPostPath.AccountPasswordReset(
                  body = ResetPasswordRequest(
                    emailAddress = mEmailInput.value.inputValue.orEmpty(),
                    locale = currentTranslationLocale.value.language,
                    resetUrlTemplate = "${BASE_URL}${View.RESET_PASSWORD.path}?token={HASH}"
                  )
                )
              )
            }
          }
        }
      }
    }
  }

}
